var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-dropdown-icon",class:{ 'menu-dropdown-icon_active': _vm.active }},[_c('img',{attrs:{"src":require("@/_shared/assets/images/icons/dropdown.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }